import clsx from 'clsx';
import styles from './SecondaryNavTitle.module.scss';

type TitleProps = {
  /**
   * Text to render in the `BetaSecondaryNavTitle`.
   */
  value: string;
  /**
   * Optional property for overriding styles.
   */
  className?: string;
};

export const BetaSecondaryNavTitle = ({ value, className }: TitleProps) => {
  return (
    <h2 className={clsx(className, styles.secondaryNavTitle)} data-zds>
      {value}
    </h2>
  );
};
